<template>
    <div class="mg-carousel mg-carousel--single" aria-hidden="true">
        <slot></slot>
    </div>
</template>

<script>
import NProgress from "nprogress";
export default {
    name: "photo-gallery",
    data() {
        return {
            flickrApi: "https://api.flickr.com/services/rest/",
            flickrApiParams: {
                api_key: "4b8c06edab112d89565c36a6f5e4dda4",
                format: "json",
                nojsoncallback: 1
            },
            options: require("../../../data-assets/slickOptions.json"),
            imagesInformation: {}
        };
    },
    methods: {
        flickrGetInfo(imgId) {
            const apiParams = {
                method: "flickr.photos.getInfo",
                photo_id: imgId,
                ...this.flickrApiParams
            };

            return $.ajax({
                url: this.flickrApi,
                data: apiParams
            });
        },
        flickrGetSizes(imgId) {
            const apiParams = {
                method: "flickr.photos.getSizes",
                photo_id: imgId,
                ...this.flickrApiParams
            };

            return $.ajax({
                url: this.flickrApi,
                data: apiParams
            });
        },
        updateGalleryItem(element) {
            const BBCode = $(element).data("bbcode");
            const imgUrl = BBCode.split("[img]")[1].split("[/img]")[0];
            const imgId = imgUrl
                .split("/")
                .pop()
                .split("_")[0];

            $(element).css("background-image", `url(${imgUrl})`);

            NProgress.start();
            Promise.all([
                this.flickrGetInfo(imgId),
                this.flickrGetSizes(imgId)
            ]).then(
                response => {
                    this.addImageInfo(response[0], element, imgId);
                    this.addDownloadLinkToImg(response[1], element, imgId);

                    NProgress.done();
                },
                error => {
                    console.log(
                        `There was an error trying to get flickr data for image: ${imgId}`
                    );

                    NProgress.done();
                }
            );
        },
        addImageInfo(data, element, imgId) {
            let photoDescription = data.photo.description._content;
            if (!photoDescription) {
                photoDescription = data.photo.title._content;
            }
            this.imagesInformation[imgId] = {
                description: photoDescription
            };
            $(element).attr("aria-label", photoDescription);
        },
        addDownloadLinkToImg(data, element, imgId) {
            const downloadLink = data.sizes.size.pop().source;
            const imageDescription = this.imagesInformation[imgId]
                ? ` - ${this.imagesInformation[imgId]["description"]}`
                : "";
            const downloadButton = `<a title="Download Image${imageDescription}" download href="${downloadLink}" class="block pin-r pin-b absolute py-4 px-6 mg-filter mg-filter--medium text-white hover:text-white plain-link text-right"><svg class="mg-icon mg-icon--medium relative z-10"><use href="#icon-download" xlink:href="#icon-download"/></svg></a>`;
            $(element).html(downloadButton);
        }
    },
    mounted() {
        $(this.$el)
            .find("[data-bbcode]")
            .map((index, element) => {
                this.updateGalleryItem(element);
            });

        this.options = {
            ...this.options,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: []
        };

        if ($.fn.slick) {
            $(this.$el).slick(this.options);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/photo-gallery.vue